import React, { Component } from 'react';
import logo from './img/dirad_logo.png';

export default class twoFactor extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			errorBg: 0,
			loginConfig: [
				{
					data: "number",
					type: "text",
					label: "Enter the Code sent to your mobile device.",
					error: ""
				}
			],
			loginCreds: {},
		}
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.login()
		}
	}

	fieldChange = (e) => {
		var newCreds = this.state.loginCreds
		newCreds[e.currentTarget.getAttribute('data-value')] = e.currentTarget.value
		this.setState({ loginCreds: newCreds })
	}

	login = (e) => {
		this.setState({ loading: true });
		//this.props.saveCreds(this.state.loginCreds)
		window.setTimeout(function () {
			this.props.ws.send(JSON.stringify({ route: 'twoFactor', loginCreds: this.state.loginCreds, session: this.props.session }))
		}.bind(this), 200)
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.setState({ loading: false, errorBg: 1 });
		}
		setTimeout(function () {
			this.setState({ errorBg: 0 });
		}.bind(this), 1000)
	}

	render() {
		const method = this.props.twoFactorMethod

		let methodBox = null;
		if (method === 'phone') {
			methodBox = <p>A verification code will be sent via <b>text</b> to your phone.</p>;
		} else if (method === 'email' || method === 'emailOnly') {
			methodBox = <p>A verification code will be sent via <b>email</b>.</p>;
		}

		var loginComps = []

		for (var comp of this.state.loginConfig) {
			let labelText = comp.label;
			if (method === 'email' || method === 'emailOnly') {
				labelText = 'Enter the code sent to your email.';
			} else if (method === 'phone') {
				labelText = 'Enter the code sent to your mobile device.';
			}
			loginComps.push(
				<div className="snazzyInputBox" key={comp.data}>
					<div className="error">{comp.error}</div>
					<input className="textInput" type={comp.type} required value={this.state.loginCreds[comp.data] ? this.state.loginCreds[comp.data] : ''} data-value={comp.data} onChange={this.fieldChange} ></input>
					<span className="inputBar"></span>
					<label className="textLabel">{labelText}</label>
				</div>
			)
		}

		return (
			<div className="App ">
				<div className="backdrop"></div>

				<div className="loginBox" onKeyUp={this.checkEnter}>
					<img src={logo} className="App-logo" alt="logo" />

					{methodBox}

					{loginComps}

					<div style={{ position: 'relative', padding: '1px', margin: '0px auto' }}>
						{this.props.loginError ? <div className="error" style={{ backgroundColor: 'rgba(144,48,112,' + this.state.errorBg + ')' }}>{this.props.loginError}</div> : ''}
						{this.state.loading ?
							<div className="loader"></div>

							:
							<div>
								<div>
									<div className="button" onClick={this.login}>Confirm Code</div>
								</div>
							</div>
						}

						{(method === 'phone' || method === 'email') && (
							<div style={{ marginTop: '10px' }}>
								{method === 'phone' ? (
									<span
										className="link"
										style={{ cursor: 'pointer', textDecoration: 'underline' }}
										onClick={() =>
											this.props.ws.send(
												JSON.stringify({ route: 'reSendTwoFactor', session: this.props.session })
											)
										}
									>
										Use email instead
									</span>
								) : (
									<span
										className="link"
										style={{ cursor: 'pointer', textDecoration: 'underline' }}
										onClick={() =>
											this.props.ws.send(
												JSON.stringify({ route: 'reSendTwoFactor', session: this.props.session })
											)
										}
									>
										Use text instead
									</span>
								)}
							</div>
						)}

						{false ? <div style={{ padding: '15px' }}>Forgot Password?</div> : ''}
					</div>
				</div >
			</div >
		)
	}
}
